import formatAmount from 'helpers/formatAmount'
import { InvoiceLine } from 'types'
import { TableProps } from 'antd'
import Big from 'big.js'

export const tableColumns: TableProps<InvoiceLine>['columns'] = [
  {
    key: 'label',
    title: 'Item',
    dataIndex: 'label',
  },
  {
    key: 'quantity',
    title: 'Quantity',
    dataIndex: 'quantity',
  },
  {
    key: 'unit',
    title: 'Unit',
    dataIndex: 'unit',
  },
  {
    key: 'price',
    title: 'Unit Price',
    dataIndex: 'product',
    render: (product) => formatAmount(Number(product.unit_price)),
  },
  {
    key: 'amount',
    title: 'Line total',
    dataIndex: 'product',
    render: (_, line: InvoiceLine) =>
      formatAmount(
        Big(Number(line.product.unit_price)).times(line.quantity).toNumber()
      ),
  },
  {
    key: 'tax',
    title: 'Tax',
    dataIndex: 'tax',
    render: (value) => formatAmount(Number(value)),
  },
]
